import * as R from "ramda";
import * as pageUtils from "./page";

// borrowed from pdf.js
const PDF_TO_CSS_UNITS = 96.0 / 72.0;
export const pdfToCssUnits = dimension => dimension * PDF_TO_CSS_UNITS;

// Construct an object from a list of keys. The second value is the default value for every key
export const objFromKeys = R.curry((keys, val) =>
  R.zipObj(keys, R.times(R.always(val), R.length(keys)))
);

export function absolutePageToRelative(page) {
  return pageUtils.absolutePageToRelative(page);
}

export function relativePageToAbsolute(page) {
  return pageUtils.relativePageToAbsolute(page);
}

export const isUIComponentVisible = R.pipe(R.values, R.any(R.equals(true)));

export const hasUserAdminGroup = () =>
  R.includes(
    "buchadmin",
    window.getClientConfiguration([], ["profile", "groups"])
  );

export const rgbaStringToObject = color => {
  color = color || "";
  const values = color.replace(/[^\d,.]/g, "").split(",");
  if (values.length < 3) return null;

  const [r, g, b, a] = values.map(c => parseFloat(c));
  return { r, g, b, a: a || 1 };
};

export const rgbaObjectToString = color =>
  `rgba(${color.r},${color.g},${color.b},${color.a})`;

export const documentsToDictionary = R.pipe(
  R.map(doc => [doc._id, doc]),
  R.fromPairs
);

export const unnestAll = R.unapply(R.unnest);

export const isEqualNoCase = a => b => R.equals(R.toLower(a), R.toLower(b));

// width and height might be switched depending on device orientation, so we
// assume it's the greater one
export const getScreenWidth = () => Math.max(window.screen.width, window.screen.height);

export const isAppleiPadDevice = () =>
  /iPad|Macintosh/.test(window.navigator.userAgent) && "ontouchstart" in window;

export const getDeviceDependentDpr = () => (getScreenWidth() < 1280 ? 1 : 2);

/**
 * Usersettings saved in uistate must not contain functions.
 * JSON.stringify removes functions by default.
 */
export const cleanUsersettings = usersettings =>
  usersettings.map(setting => ({
    ...setting,
    items: setting.items.map(item => JSON.parse(JSON.stringify(item)))
  }));

export const isDeepLink = string =>
  /^https:\/\/buch.mildenberger-digital.de/.test(string);

export const getRelativeDeeplink = string =>
  string.replace(/^https:\/\/buch.mildenberger-digital.de/, "");

export const getDeepLinkWindowName = displayAction =>
  new URL(displayAction).pathname;

export const isInIFrame = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};

export const getNoteId = (bookTitle, relativePage) =>
  `${bookTitle}@page_${relativePage}`;
